export default __webpack_public_path__ + "static/media/technology-infrared.79ef30b6.svg";